import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';

export default class HelpCenter extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    };

    render() {
        return (
            <div className="HelpCenter">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}></i>}
                >帮助中心</NavBar>
                <div className="warp">
                    <div className="content" onClick={() => this.props.history.push('/aboutMintu')}>
                        <div className="floatL">关于民途出行预约出行服务</div>
                        <i className="icon iconfont icontiaozhuan" />
                    </div>
                    <div className="content" onClick={() => this.props.history.push('/ridingKnow')}>
                        <div className="floatL">乘车须知</div>
                        <i className="icon iconfont icontiaozhuan" />
                    </div>
                    <div className="content" onClick={() => this.props.history.push('/ticketRefund')}>
                        <div className="floatL">退票收费标准</div>
                        <i className="icon iconfont icontiaozhuan" />
                    </div>
                    <div className="content" onClick={() => this.props.history.push('/invoiceApply')}>
                        <div className="floatL">关于发票申请</div>
                        <i className="icon iconfont icontiaozhuan" />
                    </div>
                    <div className="content" onClick={() => this.props.history.push('/linePrice')}>
                        <div className="floatL">关于线路价格</div>
                        <i className="icon iconfont icontiaozhuan" />
                    </div>
                    <div className="content" onClick={() => this.props.history.push('/realName')}>
                        <div className="floatL">关于实名乘车的说明</div>
                        <i className="icon iconfont icontiaozhuan" />
                    </div>
                    <div className="content" onClick={() => this.props.history.push('/childInfo')}>
                        <div className="floatL">关于儿童票的说明</div>
                        <i className="icon iconfont icontiaozhuan" />
                    </div>
                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/HelpCenter/index.js